<app-card cardTitle="Aggiungi un nuova Experience" [options]="false">
    <form action="javascript:;" [formGroup]="experienceForm">
        <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

            <aw-wizard-step stepTitle="CONFIGURAZIONE">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="titolo">TITOLO*</label>
                            <input formControlName="titolo" type="text" class="form-control" id="titolo" aria-describedby="titolo" placeholder="Titolo Experience">
                            <small id="titoloHelp" class="form-text text-muted">Scrivi un titolo che rappresenti la tua nuova Experience</small>
                        </div>
                        <div class="form-group">
                            <label for="descrizione">DESCRIZIONE AGGIUNTIVA*</label>
                            <app-tinymce formControlName="descrizione" id="descrizione" aria-describedby="descrizioneHelp"></app-tinymce>
                            <small id="descrizioneHelp" class="form-text text-muted">Scrivi una descrizione che rappresenti la tua nuova Experience</small>
                        </div>
                        <div class="form-group">
                            <label for="info">INFO</label>
                            <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                            <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Experience</small>
                        </div>
                        <div class="form-group">
                            <label for="tipologia">TIPOLOGIA</label>
                                <div>
                                    <label class="md-check">
                                      <input type="radio" value="gioco" name="tipologia" formControlName="tipologia">
                                      Gioco
                                    </label>
                                    <label class="md-check ml-3">
                                      <input type="radio" value="itinerario" name="tipologia" formControlName="tipologia">     
                                      Itinerario
                                    </label>
                                </div>
                            <small id="tipologiaHelp" class="form-text text-muted">Seleziona la tipologia per la tua experience</small>
                        </div>
                        <div class="form-group">
                            <label for="video">LINK VIDEO</label>
                            <input formControlName="video" type="text" class="form-control" id="video" aria-describedby="videoHelp" placeholder="Link video">
                            <small id="videoHelp" class="form-text text-muted">Aggiungi un link ad un video</small>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateConfigurazione()">Avanti</button>
                    </div>
                </div>
            </aw-wizard-step>

            <aw-wizard-step stepTitle="ASPETTO">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>FEATURED IMAGE</label>
                            <app-media-manager [filePath]="f.featuredImage.value" (onFileSelect)="setImageUrl($event, 'featuredImage')"></app-media-manager>
                        </div>
                        <div class="form-group">
                            <label for="primaryColor">PRIMARY COLOR</label>
                            <input formControlName="primaryColor"
                                    type="text"
                                    class="form-control"
                                    id="primaryColor"
                                    aria-describedby="primaryColorHelp"
                                    [(colorPicker)]="f.primaryColor.value"
                                    [style.background]="f.primaryColor.value"
                                    (colorPickerChange)="colorPickerPlaceholderLight(f.primaryColor.value)"
                                    [style.color]="pickerPlaceholderColor"
                                    [value]="f.primaryColor.value"
                                    [cpPosition]="'bottom'">
                            <small id="primaryColorHelp" class="form-text text-muted">Inserisci un colore per la tua nuova Experience</small>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                        <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateAspetto()">Avanti</button>
                    </div>
                </div>
            </aw-wizard-step>

            <aw-wizard-step stepTitle="ATTIVAZIONE">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="hasPeriod">PERIODO LIMITATO</label>
                            <div class="switch m-r-10">
                                <input formControlName="hasPeriod" type="checkbox" id="hasPeriod" aria-describedby="hasPeriodHelp">
                                <label for="hasPeriod" class="cr"></label>
                            </div>
                            <small id="hasPeriodHelp" class="form-text text-muted">La tua Experience potrà essere disponibile solo in un periodo di tempo limitato?</small>
                        </div>
                        <div class="form-group" *ngIf="f.hasPeriod.value">
                            <label for="periodo">PERIODO DI ATTIVAZIONE</label>
                            <div class="horizontal-scroll">
                                <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="3" [dayTemplate]="t" id="periodo" aria-describedby="periodoHelp" >
                                </ngb-datepicker>
                                <ng-template #t let-date="date" let-focused="focused">
                                    <span class="custom-day"
                                            [class.focused]="focused"
                                            [class.range]="isRange(date)"
                                            [class.faded]="isHovered(date) || isInside(date)"
                                            (mouseenter)="hoveredDate = date"
                                            (mouseleave)="hoveredDate = null">
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                                <small id="periodoHelp" class="form-text text-muted">Seleziona il periodo nel quale vuoi che sia fruibile la tua Experience</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                        <button type="button" class="btn btn-primary" awNextStep [disabled]="!validatePeriodo()">Continue</button>
                    </div>
                </div>
            </aw-wizard-step>

            <aw-wizard-step stepTitle="NAVIGAZIONE">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="fixedOrder">ORDINE INTERACTIONS</label>
                            <div class="switch m-r-10">
                                <input formControlName="fixedOrder" type="checkbox" id="fixedOrder" aria-describedby="fixedOrderHelp">
                                <label for="fixedOrder" class="cr"></label>
                            </div>
                            <small id="fixedOrderHelp" class="form-text text-muted">Indica se le Interactions potranno essere fruibili in un ordine predefinito oppure scelto liberamente dall'utente.</small>
                        </div>
                        <div class="form-group">
                            <label for="map">TIPOLOGIA DI MAPPA</label>
                            <div class="switch-field">
                                <input formControlName="mapType" type="radio" id="disabled" name="mapType" value="disabled" (click)="mapType = 'disabled'" checked/>
                                <label for="disabled">Nessuna Mappa</label>
                                <!-- <input formControlName="mapType" type="radio" id="geo" name="mapType" value="geo" (click)="mapType = 'geo'"/>
                                <label for="geo">Mappa Geografica</label> -->
                                <input formControlName="mapType" type="radio" id="image" name="mapType" value="image" (click)="mapType = 'image'"/>
                                <label for="image">Mappa Immagine</label>
                            </div>
                            <small id="mapHelp" class="form-text text-muted">Di che tipo è la mappa della tua Experience?</small>
                        </div>
                        <div class="form-group" *ngIf="mapType === 'image'">
                            <label>IMMAGINE MAPPA</label>
                            <app-media-manager [filePath]="f.imageMap.value" (onFileSelect)="setImageUrl($event, 'imageMap')"></app-media-manager>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                        <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateNavigazione()">Continue</button>
                    </div>
                </div>
            </aw-wizard-step>

            <aw-wizard-step stepTitle="PREMI">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="prizes">PRIZES</label>
                            <div class="switch m-r-10">
                                <input formControlName="hasPrizes" type="checkbox" id="prizes" aria-describedby="prizesHelp">
                                <label for="prizes" class="cr"></label>
                            </div>
                            <small id="prizesHelp" class="form-text text-muted">La tua Experience prevede l'assegnazione di premi?</small>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                        <button type="button" class="btn btn-primary" awNextStep [disabled]="!validatePremi()" (click)="saveExperience()">Salva</button>
                    </div>
                </div>
            </aw-wizard-step>

        </aw-wizard>
    </form>
  </app-card>
  